angular.module('PatientApp').factory('Subdomain', [ '$location', 'Config', function($location, Config){
    var host = $location.host();
    //On test, assume no subdomain
    //Other environments, if gopatientco is not in the url assume that there is a subdomain
    //On dev, if the url does not start with gopatientco assume that there is a subdomain
    if (Config.env !== 'test' && host.indexOf('gopatientco') < 0 || (Config.env === 'dev' && host.indexOf('gopatientco') > 0)) {
        return host.split('.')[0];
    } else {
        return null;
    }
}]);